/**
 * Metadatos SEO por ruta canónica (https://agdysa.com).
 */

export const CANONICAL_BASE = "https://agdysa.com";

export const DEFAULT_OG_IMAGE = "https://i.ibb.co/sLkXCMw/Hero.webp";

const routeSeo = {
  "/": {
    title: "AGDYSA | Inteligencia en Salud Laboral e Higiene Industrial",
    description:
      "Soluciones integrales en seguridad y salud ocupacional: exámenes médicos, mediciones higiénicas, laboratorio LABSYSO e investigación científica en El Salvador.",
    keywords:
      "salud ocupacional, higiene industrial, laboratorio clínico, AGDYSA, LABSYSO, El Salvador, estrés térmico",
  },
  "/nosotros": {
    title: "Nosotros | AGDYSA-LABSYSO",
    description:
      "Grupo acreditado ante el Ministerio de Trabajo de El Salvador. Única empresa con laboratorio clínico propio como medio instrumental en higiene ocupacional.",
    keywords: "AGDYSA nosotros, acreditación MTPS, salud laboral El Salvador, LABSYSO",
  },
  "/credibilidad": {
    title: "Credibilidad | AGDYSA — Por qué confiar en nuestra red",
    description:
      "Proveedores certificados, acreditaciones institucionales y testimonios de empresas líderes que confían en AGDYSA-LABSYSO.",
    keywords: "testimonios AGDYSA, acreditaciones, proveedores certificados, credibilidad salud ocupacional",
  },
  "/servicios": {
    title: "Servicios | Salud Ocupacional e Higiene Industrial",
    description:
      "Exámenes médicos ocupacionales, mediciones higiénicas, monitoreo de biomarcadores, capacitaciones y medicina del trabajo.",
    keywords: "servicios salud ocupacional, exámenes médicos, mediciones higiénicas, capacitación SSO",
  },
  "/calculadoras": {
    title: "Calculadoras Técnicas | AGDYSA",
    description:
      "Herramientas de cálculo para estrés térmico (WBGT), iluminación y ruido según normativa de higiene industrial.",
    keywords: "calculadora WBGT, estrés térmico, higiene industrial, ruido ocupacional",
  },
  "/investigacion": {
    title: "Investigación Científica | AGDYSA",
    description:
      "Investigación en salud ocupacional liderada por el Dr. Emmanuel Jarquín, con respaldo de Boston University y publicaciones internacionales.",
    keywords: "investigación salud ocupacional, nefropatía mesoamericana, Boston University, AGDYSA",
  },
  "/labsyso": {
    title: "LABSYSO | Laboratorio Clínico Ocupacional",
    description:
      "Laboratorio clínico de segundo nivel, acreditado OSA ISO 15189:2022 y medio instrumental ante el MTPS en higiene ocupacional.",
    keywords: "LABSYSO, laboratorio clínico, exámenes ocupacionales, ISO 15189",
  },
  "/certificaciones": {
    title: "Certificaciones y Acreditaciones | AGDYSA",
    description:
      "Catálogo oficial de certificaciones, acreditaciones y reconocimientos institucionales de AGDYSA-LABSYSO.",
    keywords: "certificaciones AGDYSA, acreditaciones salud ocupacional, MTPS",
  },
  "/contacto": {
    title: "Cotizaciones y Contacto | AGDYSA",
    description:
      "Solicite su cotización personalizada para servicios de salud ocupacional, exámenes médicos y capacitaciones técnicas.",
    keywords: "cotizar salud ocupacional, contacto AGDYSA, presupuesto exámenes médicos",
  },
  "/privacidad": {
    title: "Aviso de privacidad | AGDYSA",
    description:
      "Información sobre el tratamiento de datos personales en el sitio AGDYSA-LABSYSO, conforme a la legislación de El Salvador.",
    keywords: "aviso de privacidad AGDYSA, protección de datos, El Salvador",
  },
  "/cookies": {
    title: "Política de cookies | AGDYSA",
    description:
      "Cookies y tecnologías similares usadas en agdysa.com: esenciales, funcionales y contenido de terceros.",
    keywords: "política de cookies AGDYSA, consentimiento, privacidad",
  },
};

export function getSeoForPath(pathname) {
  const path = pathname.split("?")[0].replace(/\/$/, "") || "/";
  const config = routeSeo[path] || routeSeo["/"];

  return {
    title: config.title,
    description: config.description,
    keywords: config.keywords,
    ogImage: config.ogImage || DEFAULT_OG_IMAGE,
    url: path === "/" ? CANONICAL_BASE : `${CANONICAL_BASE}${path}`,
  };
}
